import React, { useEffect, useRef, useState } from 'react'

interface Props{
  handleVerifCodeSubmit: (val:string)=>void
  handleResendCodeSubmit: ()=>void
  // canResendOnce: boolean
  errorCode:boolean
  setErrorCode:(val:boolean)=>void
  prefixe:string
  phone:string
}

const VerifCode: React.FC<Props> = ({
  handleVerifCodeSubmit, handleResendCodeSubmit, errorCode, setErrorCode, prefixe, phone
}) => {
    const [code, setCode]=useState(Array(6).fill(''))
    const [numberClic, setNumberClic]= useState(0)
    const [compteur, setCompteur]= useState(20)
    const InputRef= useRef<(HTMLInputElement |null)[]>([])
    const fullCode= code.join('')

    useEffect(()=>{
      if(errorCode || numberClic!==0)
      {
        setCode(Array(6).fill(''))
        InputRef.current[0]?.focus
      }
    },[errorCode, numberClic])

    useEffect(()=>{
      if (compteur === 0) return
      const interval = setInterval(()=>{
       setCompteur((prev)=>(prev > 0 ? prev -1 : 0))
      },1000)
      return()=>clearInterval(interval)

    }, [compteur])

    useEffect(()=>{
      if(fullCode.length===1 && errorCode === true)
      {setErrorCode(false)}
    },[fullCode])
     
    const handleChange=(e: string, index:number)=>{
        if (!/^[0-9]?$/.test(e)) return 
        const newCode=[...code]
        newCode[index]=e
        setCode(newCode)
        if(index < 5 && e){
          InputRef.current[index+1]?.focus()
        }
        if(index > 0 && !e){
          InputRef.current[index-1]?.focus()
        }
    }
  return (
    <div className='flex flex-col items-center justify-center text-center mt-[30px] mb-5 font-roboto  '>
      <h1 className='h2 text-center'>Vérifiez votre numéro</h1>
      <p className='text-[#6B7280] font-roboto mt-5'>Un code à 6 chiffres vous a été envoyé <br/>au +{prefixe} {phone.slice(0,4)} xxx xxx</p>
      <div className='flex gap-2 h-[100px] items-center my-3'>
        {code.map((val,index)=>(
            <input
                
                ref={(val)=>(InputRef.current[index]=val)}
                key={index}
                className='w-[48px] h-[48px] text-center  outline-none border border-[#AEB6FB] placeholder:text-[#D1D1FF] rounded-[14px] focus:border-[#5754E5] text-[#35258B] shadow-selct shadow-[#5754E5]/10'
                type='text'
                value={val}
                onChange={(e)=>handleChange(e.target.value, index)}
            />

        ))}
      </div>
      <button
      onClick={()=>{handleVerifCodeSubmit(fullCode)}}
      // disabled={fullCode.length!== 6 && compteur===0 }
      disabled={fullCode.length !== 6 && compteur===0  }
        className={` ${fullCode.length === 6 && compteur!==0   ? 'bg-[#4743C9] ' : 'bg-[#D1D1FF]'}  text-[#FFF] h-[56px] rounded-[16px] w-[358px] `}
        >
        Valider
      </button>
       <div className='h-[50px] flex flex-col items-center justify-center'>
         <p className='text-[#EE443F] text-[14px] sm:text-[12px]  flex items-center justify-center w-[350px]'>
         {numberClic > 1 ? 'Veuillez contacter notre service client sur : +33 7 45 89 60 62'
         : errorCode && fullCode.length !== 1 && 'Vérifiez votre code !'}
        </p>
        {(numberClic <2 && compteur!==0) && <div className='text-[#6B7280]  '>Renvoyer le code dans 00:{compteur}</div>}
    
       </div>


        <button
        onClick={()=>{handleResendCodeSubmit(),          
          setNumberClic(prev=>(prev+1))
          setCompteur(20)
        }}
        disabled={numberClic > 2 && compteur!==0 }
        className={` ${numberClic < 2 && compteur===0  ? 'text-[#4743C9] border-[#5754E5] ' : 'text-[#D1D1FF] border-[#D1D1FF] '}  border  h-[56px] rounded-[16px] w-[358px] `}
        >
        Renvoyer le code
      </button>
      
      <div className=' text-[#8F8FCD] mt-5 sm:text-[14px]'>
        Si vous n’avez pas reçu votre code d’activation par 
        <br/> sms, vous pouvez contacter notre service client <br/>
        via e-mail :<a className='text-[#5754E5] ' href='mailto:contact@myeasytransfer.com' target=''> support@myeasytransfer.com</a>
        <br/>ou par téléphone au <a href='tel:+0033745896062' className='text-[#5754E5] outline-none' > 0033745896062</a>
        {/* <br/>ou <a href='tel:+0033745897010' className='text-[#5754E5]'> 0033745897010</a>. */}
      </div>
    </div>
  )
}

export default VerifCode
